  document.addEventListener('DOMContentLoaded', () => {
    const lightboxIcons = document.querySelectorAll('.product__media-icon--lightbox');
    if (!lightboxIcons.length) return;
    lightboxIcons.forEach((icon) => {
      const modalOpener = icon.closest('.product__modal-opener');
      const modalId = modalOpener ? modalOpener.getAttribute('data-modal') : null;
      const modal = modalId ? document.querySelector(modalId) : null;
      const imageSrc = icon.closest('.product-media-container')?.querySelector('img')?.src || '';
      icon.addEventListener('click', (event) => {
        if (modal) {
          modal.show ? modal.show() : (modal.style.display = 'block');
        } else if (imageSrc) {
          const lightbox = document.createElement('div');
          lightbox.style.cssText = `
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0,0,0,0.8); z-index: 9999; display: flex;
            justify-content: center; align-items: center;
          `;
          const img = document.createElement('img');
          img.src = imageSrc;
          img.style.maxWidth = '90%';
          img.style.maxHeight = '90%';
          lightbox.appendChild(img);
          lightbox.addEventListener('click', () => lightbox.remove());
          document.body.appendChild(lightbox);
        }
      });
    });
  });